export default "__VITE_ASSET__BBvZilFt__"